export default function (element, data) {
    const filterOptions = element.querySelectorAll(".filter-option");
    const applyButton = element.querySelector(".apply-button");
    const baseUrl = data.baseUrl;
    
    updateLink();

    filterOptions.forEach(option => {
        option.addEventListener("click", function () {
            const key = option.dataset.key;
            const value = option.dataset.value;

            filterOptions.forEach(option => {
                if (option.dataset.key == key && option.dataset.value != value) {
                    option.classList.remove("option-current");
                }
            });
            
            option.classList.toggle("option-current");
            updateLink();
        });
    });

    function updateLink() {
        const urlData = {};
        filterOptions.forEach(option => {
            if (option.classList.contains("option-current")) {
                const key = option.dataset.key;
                const value = option.dataset.value;

                urlData[key] = value;
            }
        });

        const url = baseUrl + Object.entries(urlData).sort(function (a, b) {
            return (a[0]<b[0]?-1:(a[0]>b[0]?1:0));  
        }).map(function (param) {
            return param[0] + "/" + param[1];
        }).join("/");

        applyButton.href = url;
    }
}